const FORBIDDEN_CHARS_REG = /["']/gi

export const sanitizeAndTruncateString = string => {
  if (!string) return ''

  return string
    .replace(/<[^>]*>/g, '') // remove HTML tags
    .replace(/[\t\n\v\r]/g, '')
    .replace(FORBIDDEN_CHARS_REG, '')
    .slice(0, 100)
}

export const calcClusterStat = lassoData => {
  if (!lassoData) return null

  const { points, border, pointsSelectionIndexes } = lassoData
  const comments = points.filter(point => point?.comment)
  const users = points.reduce((res, p) => {
    if (!res.includes(p.uid)) {
      res.push(p.uid)
    }
    return res
  }, [])

  return {
    border,
    points: pointsSelectionIndexes,
    stat: {
      points: points.length,
      comments: comments.length,
      respondents: users.length
    }
  }
}

export const calcClusterModel = (cluster, lassoData) => {
  const clusterModel = { ...cluster }
  const title = clusterModel.title

  clusterModel.title = !title || title.trim() === '' ? 'Cluster' : title.trim()

  if (lassoData) {
    const clusterStat = calcClusterStat(lassoData)
    clusterModel.border = clusterStat.border
    clusterModel.points = clusterStat.points
    clusterModel.stat = clusterStat.stat
  }

  return clusterModel
}

// no /g here — a shared global regex keeps lastIndex between .test() calls
export const isForbiddenChar = key => /["']/.test(key)

export const getRandomColor = () =>
  '#' + Array.from({ length: 6 }, () => '0123456789ABCDEF'[Math.floor(Math.random() * 16)]).join('')
